import {createElement, removeElement} from '../utils/dom.js';
import {formatPrice} from '../utils/formatprice.js';
import {positionRelativeTo} from '../utils/positionrelativeto.js';
import {render, html, nothing} from '../lib/lit-html.js';

function composeResult(state, result, currency){
	return html`
		<div class="ekm-search-predicted-result">
			${composeResultImg(result)}
			<a class="ekm-search-predicted-result-name-a" data-id=${result.id} href=${result.url}>
				<div class="ekm-search-predicted-result-name">${result.name}</div>
				${state.showPrices 
					? html`<div class="ekm-search-predicted-result-price">${formatPrice(result.price, currency)}</div>` 
					: nothing}
			</a>
		</div>
	`;
}

function composeResultImg(result){
	if (!result.image_url) return [];

	return html`
		<div class="ekm-search-predicted-result-img">
			<a class="ekm-search-predicted-result-img-a" href=${result.url}>
				<img src=${result.image_url} title=${result.name} />
			</a>
		</div>
	`;
}

export class PredictedResultsView {
	constructor(store){
		this._store = store;
		this._isVisible = false;
		this._element = createElement('div.ekm-search-predicted-results');
		this._element.addEventListener('click', this._onViewAllClick.bind(this));
		this._element.addEventListener('click', this._onResultClick.bind(this));

		store.subscribe(this._onStateChange.bind(this));
	}

	_onViewAllClick(event){
		if (!event.target.closest('.ekm-search-predicted-results-all')) return;

		this._store.dispatch({
			type: 'VIEW_ALL_RESULTS'
		});
	}

	_onResultClick(event){
		const a = event.target.closest('.ekm-search-predicted-result-name-a');

		if (!a) return;

		const id = a.dataset.id;

		this._store.dispatch({
			type: 'PREDICTED_RESULT_SELECT',
			result: this._store.getState().suggestions.items.find(s => s.id == id),
		});
	}

	_onStateChange(state){
		if (state.suggestions.items.length === 0 || state.inputs.activeElement === null){
			if (!this._isVisible) return;
			removeElement(this._element);
			this._isVisible = false;
			return;
		}

		if (!this._isVisible){
			document.body.appendChild(this._element);
			this._isVisible = true;
		}

		render(this._compose(state), this._element)

		this._positionElement(state);
	}

	_compose(state){
		var results = state.suggestions.items;
		return html`
			${results.map(r => composeResult(state, r, state.currency))}
			<div class="ekm-search-predicted-results-all">
				<div class="ekm-search-predicted-results-all-text">View all results</div>
				<i class="shopui-icon shopui-icon-chevron-right"></i>
			</div>
		`;
	}

	_positionElement(state){
		var refElement;

		if (state.suggestions.queries.length === 0){
			let input = state.inputs.elements[state.inputs.activeElement]

			var anchorSelector = getComputedStyle(input)
				.getPropertyValue('--ekm-search-anchor');

			refElement = (anchorSelector !== '')
				? input.closest(anchorSelector) || input
				: input;
		}
		else {
			refElement = document.querySelector('.ekm-search-suggested-queries');
		}

		positionRelativeTo(this._element, refElement)
	}
}